// Expected failures are values, not exceptions (guidelines §5).
export type Result<E, A> = { readonly tag: "error"; readonly error: E } | { readonly tag: "ok"; readonly value: A }

export const ok = <A>(value: A): Result<never, A> => ({ tag: "ok", value })
export const err = <E>(error: E): Result<E, never> => ({ tag: "error", error })
